import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CheckShieldIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.7075 3.63279L10.0671 0.112507L9.94871 0.0651487C9.60685 -0.0217162 9.2487 -0.0217162 8.90683 0.0651487L8.78844 0.112507L1.148 3.63279C0.787115 3.79895 0.48479 4.07018 0.280587 4.41099C0.0763839 4.75179 -0.0201855 5.14631 0.00351503 5.5429L0.271878 10.0261C0.424166 12.6047 1.30641 15.0869 2.81571 17.1831C4.32502 19.2794 6.39919 20.9034 8.79633 21.8657C8.99723 21.9561 9.21536 22.0019 9.43567 21.9998C9.64509 22.003 9.85263 21.9599 10.0434 21.8735C12.4435 20.9136 14.521 19.2907 16.0332 17.1942C17.5455 15.0978 18.43 12.6144 18.5837 10.034L18.852 5.55079C18.8774 5.1529 18.7816 4.75666 18.5773 4.41428C18.373 4.0719 18.0697 3.79944 17.7075 3.63279ZM13.5716 9.1579L9.35674 13.8937C9.28817 13.9722 9.20474 14.0363 9.11126 14.0823C9.01779 14.1284 8.91612 14.1555 8.81212 14.1621H8.77265C8.57432 14.1635 8.3827 14.0903 8.23593 13.9569L5.33919 11.289C5.18533 11.1467 5.09432 10.949 5.08618 10.7396C5.07804 10.5301 5.15343 10.326 5.29578 10.1722C5.43813 10.0183 5.63577 9.92728 5.84522 9.91914C6.05467 9.911 6.25878 9.98639 6.41264 10.1287L8.7174 12.252L12.3877 8.11602C12.5285 7.96934 12.7206 7.88271 12.9238 7.87418C13.127 7.86565 13.3257 7.93589 13.4783 8.07025C13.631 8.20461 13.7259 8.39272 13.7433 8.59535C13.7607 8.79799 13.6992 8.99951 13.5716 9.1579Z"
        fill="currentColor"
      />
    </svg>
  )
})

CheckShieldIcon.displayName = 'CheckShieldIcon'
